import { render } from "./PageHeader.vue?vue&type=template&id=794d7f53"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "794d7f53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('794d7f53', __exports__)) {
    api.reload('794d7f53', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=794d7f53", () => {
    api.rerender('794d7f53', render)
  })

}


export default __exports__